import PropTypes from 'prop-types';
import { clsx } from 'clsx';

/**
 * Testimonial Card component for displaying patient reviews
 */
const TestimonialCard = ({
  name,
  role,
  content,
  avatar,
  rating = 5,
  className = '',
}) => {
  return (
    <article
      className={clsx(
        'bg-white rounded-2xl p-6 shadow-soft',
        'border border-neutral-100',
        className
      )}
    >
      {/* Star Rating */}
      <div className="flex gap-1 mb-4" aria-label={`Rating: ${rating} out of 5 stars`}>
        {[...Array(5)].map((_, index) => (
          <svg
            key={index}
            className={clsx(
              'w-5 h-5',
              index < rating ? 'text-yellow-400' : 'text-neutral-200'
            )}
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>

      {/* Quote Content */}
      <blockquote className="mb-6">
        <p className="text-neutral-700 leading-relaxed italic">
          &ldquo;{content}&rdquo;
        </p>
      </blockquote>

      {/* Author Info */}
      <footer className="flex items-center gap-4">
        {avatar ? (
          <img
            src={avatar}
            alt=""
            className="w-12 h-12 rounded-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
            <span className="text-primary-600 font-semibold text-lg">
              {name.charAt(0)}
            </span>
          </div>
        )}
        <div>
          <cite className="not-italic font-semibold text-neutral-900">
            {name}
          </cite>
          {role && (
            <p className="text-sm text-neutral-500">{role}</p>
          )}
        </div>
      </footer>
    </article>
  );
};

TestimonialCard.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string,
  content: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  rating: PropTypes.number,
  className: PropTypes.string,
};

export default TestimonialCard;
